import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  ViewChild,
} from '@angular/core';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'conn-checkbox-toggle',
  templateUrl: './checkbox.component.html',
  styleUrls: ['./checkbox.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class CheckboxComponent implements AfterViewInit, OnChanges {
  @ViewChild('checkbox') checkboxInput: ElementRef;
  @Input() isOn: boolean;
  @Input() labelName: string;
  @Input() disabled: boolean;
  @Output() checkboxEmitter: EventEmitter<boolean>;
  environment = environment;

  constructor() {
    this.checkboxEmitter = new EventEmitter<boolean>();
  }

  ngAfterViewInit() {
    this.ngOnChanges();
  }

  ngOnChanges() {
    if (this.isOn && this.checkboxInput) {
      this.checkboxInput.nativeElement.checked = true;
    }
  }

  toggle() {
    if (this.isOn === undefined) {
      this.isOn = false;
    }
    this.isOn = !this.isOn;
    if (this.checkboxInput.nativeElement.checked !== this.isOn) {
      this.checkboxInput.nativeElement.checked = this.isOn;
    }
    this.checkboxEmitter.emit(this.isOn);
  }
}
